import { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { useMantineColorScheme } from "@mantine/core";

interface DetailContentProps {
  children: React.ReactNode;
}

export const DetailContent = ({ children }: DetailContentProps) => {
  const { colorScheme } = useMantineColorScheme();
  return <Content theme={{ colorScheme }}>{children}</Content>;
};

const Content = styled.div<{ theme: Theme & { colorScheme: "dark" | "light" } }>`
  background-color: ${({ theme }) =>
    theme.colorScheme === "dark" ? "var(--gray-9, #1e1e1e)" : "white"};
`;
